import { StudentPage, StudentSection } from './StudentUI';
import StudentIdCard from './StudentIdCard';

const StudentIdCardPage = () => (
  <StudentPage
    title="Student ID"
    subtitle="Use this card for reception, attendance, and academy verification."
  >
    <StudentSection
      title="ID card"
      description="Your academy student card is ready to print when you need it."
      className="print:border-0 print:shadow-none"
    >
      <StudentIdCard showPrintButton />
    </StudentSection>
  </StudentPage>
);

export default StudentIdCardPage;
